import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { change_password_api } from "../../DAL/Users";
import FormButtons from "../GeneralComponents/FormButtons";
import { useSnackbar } from "notistack";

export default function ChangePassword({ handleClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const [passwordType, setPasswordType] = useState({
    old_password: "password",
    new_password: "password",
    confirm_password: "password",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChangeIcon = (name) => {
    const updateName = `${name}_password`;
    let password_type = "password";
    if (passwordType[updateName] === "password") {
      password_type = "text";
    }
    setPasswordType((old) => ({ ...old, [updateName]: password_type }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Validation example
    if (formData.new_password !== formData.confirm_password) {
      enqueueSnackbar(`New password and confirm password do not match!`, { variant: "error" });
      setIsLoading(false);
      return;
    }

    const payload = {
      old_password: formData.old_password,
      new_password: formData.new_password,
      confirm_password: formData.confirm_password,
    };

    const result = await change_password_api(payload);
    if (result.code === 200) {
      enqueueSnackbar(`${result.message}`, { variant: "success" });
      setIsLoading(false);
      handleClose();
    } else {
      enqueueSnackbar(`${result.message}`, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="change-password-modal">
      <form className="input-form" onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <div className="input-wrapper position-relative">
            <Icon icon="mdi:lock-outline" className="input-icon" />
            <Icon
              icon={`mdi:eye${
                passwordType.old_password == "password" ? "-off" : ""
              }`}
              className="eye-icon"
              onClick={() => handleChangeIcon(`old`)}
            />
            <input
              type={passwordType.old_password}
              name="old_password"
              className="form-control ps-5"
              placeholder="Old Password"
              value={formData.old_password}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group mb-3">
          <div className="input-wrapper position-relative">
            <Icon icon="mdi:lock-reset" className="input-icon" />
            <Icon
              icon={`mdi:eye${
                passwordType.new_password == "password" ? "-off" : ""
              }`}
              className="eye-icon"
              onClick={() => handleChangeIcon(`new`)}
            />
            <input
              type={passwordType.new_password}
              name="new_password"
              className="form-control ps-5"
              placeholder="New Password"
              value={formData.new_password}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group mb-3">
          <div className="input-wrapper position-relative">
            <Icon icon="mdi:lock-check-outline" className="input-icon" />
            <Icon
              icon={`mdi:eye${
                passwordType.confirm_password == "password" ? "-off" : ""
              }`}
              className="eye-icon"
              onClick={() => handleChangeIcon(`confirm`)}
            />
            <input
              type={passwordType.confirm_password}
              name="confirm_password"
              className="form-control ps-5"
              placeholder="Confirm Password"
              value={formData.confirm_password}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="d-flex gap-3 justify-content-end mt-4">
          <FormButtons
            {...{ isLoading, handleCancel: handleClose, isRelative: true }}
          />
        </div>
      </form>
    </div>
  );
}
